export const PURPLE = '#654BAD';
export const BACKGROUND_COLOR = '#121212';
export const GRAY = '#353535';
export const GRAY_LIGHT = '#797881';
